import IntegrationsConnectButton from './IntegrationsConnectButton';
import { useTranslation } from 'react-i18next';
import ConnectIcon from '@/icons/connect.svg?react';

interface Props {
  isConnected?: boolean;
  onClickConnect: () => void;
  iconSrc: string;
  name: string;
  label: string;
}

export const IntegrationWidget = ({
  isConnected,
  onClickConnect,
  iconSrc,
  name,
  label,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className='flex items-center justify-between font-bold'
        data-testid={`integrations-${name}`}
      >
        <div className='flex items-center'>
          <img
            src={iconSrc}
            alt={name}
            style={{
              width: 40,
              height: 40,
            }}
            className='mr-2 flex-shrink-0'
          />
          <span>{label}</span>
        </div>
        {isConnected ? (
          <div>
            <ConnectIcon className='Integrations__validIcon' />
          </div>
        ) : (
          <IntegrationsConnectButton
            testId={`${name}-btn`}
            onClick={onClickConnect}
          />
        )}
      </div>
      {isConnected && (
        <div className='mt-2'>
          <div className='flex items-center justify-between'>
            <div>{t('Connected')}</div>
          </div>
        </div>
      )}
    </>
  );
};
